import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GIButton, Modal } from 'app-components';
import { useDispatch, useSelector } from 'react-redux';

import { useApiHandler } from '../hooks/useApiHandler';
import { StyledModal } from '../constants/ticketlist.styled';
import { formatDate } from '@utils/dates/date.utils';
import { DATE_FORMATS } from '@utils/dates/dateMethods';
import { IExportTicketsModal } from '../constants/ticketlist.interface';
import { DEFAULT_PAYLOAD, TICKET_LIST_SEARCH_VARS } from '../constants/ticketlist.constants';
import { formatFilterValue, getItemFromSessionStorage } from '../constants/ticketlist.utils';

export const ExportTicketsModal = ({ onClose, isAdvanceSearch }: IExportTicketsModal) => {
    const dispatch = useDispatch();
    const { exportTicketListAPI } = useApiHandler();
    const onSubmit = async () => {
        const searchCriteria = getItemFromSessionStorage(TICKET_LIST_SEARCH_VARS);
        let payload = {
            ...DEFAULT_PAYLOAD,
            'role.id': '',
            taskStatus: '',
            isSimplifiedView: false,
        } as Record<string, any>;
        ['pageNumber', 'sortBy', 'sortOrder'].forEach(key => delete payload[key]);

        if (isAdvanceSearch) {
            payload = {
                ...payload,
                isSimplifiedView: searchCriteria.isSimplifiedView || false,
                ticketSubject: searchCriteria.ticketSubject || '',
                ticketComments: searchCriteria.ticketComments || '',
                ticketNumber: searchCriteria.ticketNumber || '',
                ticketQueues: searchCriteria.ticketQueues || '',
                ticketPriority: searchCriteria.ticketPriority || '',
                watchStatusAdvanced: searchCriteria.watchStatusAdvanced || '',
                ticketStatus: searchCriteria.ticketStatus || '',
                requester: searchCriteria.requester || '',
                submittedAfter: searchCriteria.submittedAfter
                    ? formatDate(searchCriteria.submittedAfter, DATE_FORMATS.MM_DD_YYYY) || ''
                    : '',
                submittedBefore: searchCriteria.submittedBefore
                    ? formatDate(searchCriteria.submittedBefore, DATE_FORMATS.MM_DD_YYYY) || ''
                    : '',
                assignee: searchCriteria.assignee || '',
                assigneeId: searchCriteria.assigneeId || '',
                requestedByName: searchCriteria.requestedByName || '',
                requestedBy: searchCriteria.requestedBy || '',
                requestedBytagId: searchCriteria.requestedBytagId || '',
                tagId: searchCriteria.tagId || '',
                userRole: searchCriteria.userRole || '',
                roleId: searchCriteria.roleId || '',
                customFieldSelect: searchCriteria.customFieldSelect || -1,
                customFieldSelectVal: searchCriteria.customFieldSelectVal || '',
                ticketCategorySelect: searchCriteria.ticketCategorySelect || -1,
                archiveFlagValue: false,
                isReportPageCall: searchCriteria.isReportPageCall || '',
                workGroupBytagId: searchCriteria.workGroupBytagId || '',
                ticketType: searchCriteria.ticketType || '',
                csrftoken: window.csrf_token,
            };
        } else {
            payload = {
                ...payload,
                filterticketStatus: formatFilterValue(searchCriteria.filterticketStatus) || '',
                userticketQueues: formatFilterValue(searchCriteria.userticketQueues) || '',
                userFilter: searchCriteria.userFilter || '',
            };
        }
        await exportTicketListAPI(dispatch, payload);
        onClose();
    };

    return (
        <StyledModal>
            <Modal id="exportTicketModal" data-testid="export-ticket-modal">
                <Modal.Header
                    id="exportTicketModalHeader"
                    titleId="ticketList.modal.exportTicket.header"
                    data-testid="export-ticket-modal-header"
                    onHide={onClose}
                />
                <Modal.Body data-testid="export-ticket-modal-body">
                    <FormattedMessage
                        id="ticketList.modal.exportTicket.body"
                        values={{
                            br: <br />,
                        }}
                    />
                </Modal.Body>
                <Modal.Controls data-testid="export-ticket-modal-controls">
                    <GIButton
                        id="exportTicketModalNoButton"
                        onClickHandler={onClose}
                        variant="secondary"
                        labelId="common.cancel"
                    />
                    <GIButton
                        id="exportTicketModalYesButton"
                        onClickHandler={onSubmit}
                        variant="primary"
                        labelId="button.export"
                    />
                </Modal.Controls>
            </Modal>
        </StyledModal>
    );
};
